import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, d3Bullet, responsivefy} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    var chart1 = d3Bullet(chart).width(chart.width).height(chart.height)

    console.log("Chart vizName called:", vizName)

    //Loading json data
    axios.post(url, filterParam).then(res => {
        let data = res.data
        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
            var y1tip = tooltip_class()

            y1tip.attr('class', 'd3-tip'+divId.id)
                .html((d) =>{
                    return ("<b>Value -> <span style='color:#0000cc'>Current"+colonAnnotation + d.measures[0]
                        + "</span>; <span style='color:#6666ff'>Projected"+colonAnnotation + d.measures[1]
                        + "</span>; Previous"+colonAnnotation + d.markers
                        + "<br>Target -> <span style='color:#e6e600'>Minimal"+colonAnnotation + d.ranges[0]
                        + "</span>; <span style='color:#80ff80'>Nominal"+colonAnnotation + d.ranges[1]
                        + "</span>; <span style='color:#1f7a1f'>Stretch"+colonAnnotation + d.ranges[2]
                        + "</span></b>")
                })*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        var svg = d3.select(divId).selectAll("svg").remove();

        //svg.call(y1tip)

        svg = d3.select(divId)
            .selectAll('react')
            .data(data)
            .enter()
            .append('svg')
            .attr('class', 'bullet')
            .attr('width', chart.width + chart.margin.left + chart.margin.right)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')
            .call(chart1)
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html("<b>Value -> <span style='color:#0000cc'>Current" + colonAnnotation + d.measures[0]
                    + "</span>; <span style='color:#6666ff'>Projected" + colonAnnotation + d.measures[1]
                    + "</span>; Previous" + colonAnnotation + d.markers
                    + "<br>Target -> <span style='color:#e6e600'>Minimal" + colonAnnotation + d.ranges[0]
                    + "</span>; <span style='color:#80ff80'>Nominal" + colonAnnotation + d.ranges[1]
                    + "</span>; <span style='color:#1f7a1f'>Stretch" + colonAnnotation + d.ranges[2]
                    + "</span></b>"
                )
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })
        //.on('mouseover', y1tip.show)
        //.on('mouseout', y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        var title = svg.append('g').style('text-anchor', 'end').attr('transform', 'translate(-6,' + chart.height / 2 + ')')

        title.append('text').attr('class', 'title').text(d => {
            return d.title
        })
        title.append('text').attr('fill', '#999').attr('dy', '2em').text(d => {
            return d.subtitle
        })
    })
}
